import { useCallback } from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';

import { type MonetizationEventsCurrentEvent } from '../../../dto/monetization-events.types';
import { SportEventType } from '../../../dto/sport.types';
import { useFlag } from '../../../services/launchDarkly';
import { useStores } from '../../../stores/useStores';
import { devError } from '../../../utils/log';
import { Loader } from '../../Loader/Loader';
import { Timer } from '../../Timer/Timer';
import classes from '../MonetizationEventsDialog/MonetizationEvents.module.scss';

export const SportsWidget = observer(({ event }: { event: MonetizationEventsCurrentEvent }) => {
  const { monetizationEventsStore, sportEventsStore } = useStores();
  const { widgetImageUrl } = event;
  const isSportsWidgetEnabled = useFlag('crown_sports_feature', false);

  const onClickHandler = () => {
    if (!event) {
      devError('MonetizationEventWidget onClickHandler error: Event is undefined');
      return;
    }

    const analyticsParams = {
      event_action: 'click',
      triggered_by: 'click',
      click_location: 'widget',
    } as const;

    let feature_sub_type: SportEventType;

    switch (event.gameNameType) {
      case SportEventType.GAME_OF_THE_DAY:
        void sportEventsStore.startSportEvent();
        feature_sub_type = SportEventType.GAME_OF_THE_DAY;
        break;
      default:
        devError(`MonetizationEventWidget onClickHandler error: Unknown event type ${event.gameNameType}`);
        return;
    }

    void monetizationEventsStore.sendAnalyticsEvent({ ...analyticsParams, feature_sub_type });
  };

  const onTimerEnd = useCallback(() => {
    void monetizationEventsStore.fetch();
  }, [monetizationEventsStore]);

  const imageUrl = widgetImageUrl;

  const isLoading = sportEventsStore.isLoadingGame;

  if (!isSportsWidgetEnabled) {
    return null;
  }

  return (
    <div className="home-widget" data-testid="sports-widget">
      <div className={classNames(classes.monetizationEventWidget, 'monetizationEventWidget', event.gameNameType)}>
        <div className={classNames(classes.widget, 'circle-parent')} onClick={onClickHandler}>
          <div className="circle" />
          <img alt="Widget" className={classes.icon} src={imageUrl} />
          <Timer
            className={classNames(classes.timer, 'widget-timer')}
            endDate={new Date(event.endDate)}
            style={{ display: 'none' }}
            onTimerEnd={onTimerEnd}
          />
        </div>
        {isLoading && <Loader cover fullScreen />}
      </div>
    </div>
  );
});
